<template>
  <van-tabbar v-if="active != -1" v-model="active" style="position: relative">
    <template v-for="item in list" :key="item">
      <van-tabbar-item :icon="item.icon" :badge="item.badge" @click="onTo(item.to)">
        <template v-if="item.prefix" #icon="props">
          <i
            class="van-badge__wrapper van-icon"
            :class="{ [item.prefix]: true, [`my-icon-${item.icon}`]: true, active: props.active }"
          ></i>
        </template>
        {{ item.text }}</van-tabbar-item
      >
    </template>
  </van-tabbar>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import router, { asyncRouterMap } from '@/router'
import { useRouter, useRoute } from 'vue-router'
import { useTabbarStoreWithOut } from '@/store/modules/Tabbar'
import onApiGlobalTimer from '@/utils/apiGlobalTimer'

const { replace } = useRouter()

onApiGlobalTimer()

const TabbarStore = useTabbarStoreWithOut()

const list: any = ref([])

watch(
  () => [TabbarStore.pendingApproval],
  () => {
    list.value = list.value.map((v: any) => {
      if (v.text === '我的审批') {
        v.badge = TabbarStore.pendingApproval > 0 ? TabbarStore.pendingApproval : false
      }

      return v
    })
  },
  {
    immediate: true,
    deep: true
  }
)

const active = ref(0)

const onTo = (url) => {
  replace(url)
}

const isxiegang = (row) => {
  return row.includes('/') ? row : `/${row}`
}

const onMatchTheRoute = (url) => {
  let dangqiandizhi: any = asyncRouterMap.find((v) => v.path.includes(url))
  list.value =
    dangqiandizhi.children.map((v) => {
      let url = dangqiandizhi.path + isxiegang(v.path)
      if (v.children && Array.isArray(v.children) && v.children.length > 0) {
        url += `/${v.children[0].path}`
        url = url.replace('//', '/')
      }

      return {
        prefix: v.meta?.prefix || false,
        icon: v.meta.icon,
        text: v.meta.title,
        to: url,
        badge: false
      }
    }) || []
}

router.afterEach(async (to, as, asd) => {
  try {
    let genlujing = to.path.split('/').filter((v) => v != '')[0]
    await onMatchTheRoute(genlujing)
    active.value = list.value.findIndex((item) => item.to === to.path)
  } catch (e) {
    console.error(e)
  }
})
</script>
